module.exports = __webpack_public_path__ + "files/d076181c78d41caf12182078f3d138a8.png";